// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { fetchDeviceStatuses } from '../api/devices'
import { message } from 'antd'
import moment from "moment";

interface IStatusTraceState {
  deviceId?: number
  isTraceEnable: boolean
  isStatusTrackerVisible: boolean
  currentStatuses: []
  traceStartTime: any
  traceEndTime: any
}

export const statusTrace = {
  state: {
    currentStatuses: []
  } as IStatusTraceState,
  reducers: {
    updateState: (state, payload) => ({ ...state, ...payload }),
    updateStatusTraceTime: (state, traceStartTime, traceEndTime) => ({ ...state, traceStartTime, traceEndTime }),
    clear () {
      return {
        currentStatuses: []
      }
    }
  },
  effects: dispatch => ({
    async fetchAndUpdateDeviceStatuses (_, state) {
      
      const { deviceId, traceTime } = state.gpsTrace
      //const { traceStartTime, traceEndTime } = state.statusTrace
      if (!deviceId) {
        return this.updateState({
            currentStatuses: []
        })
      }
      try {
        let statusTraces
        const [startDate, endDate] = traceTime
        // let traceStartTime = moment().add(0-traceTime,'days');
        let traceStartTime = startDate.clone();
        let traceEndTime = endDate.clone();

        statusTraces = await fetchDeviceStatuses({
            deviceId,
            startTime: traceStartTime.format('YYYY-MM-DD HH:mm:ss'),
            endTime: traceEndTime.format('YYYY-MM-DD HH:mm:ss')
        })
        this.updateState({
          currentStatuses: [statusTraces.results.deviceStatuses]
        })
        if (statusTraces.results.deviceStatuses.length == 0) {
          message.info('No status records')
        }
      } catch (e) {
        message.info('Fetch status data failed')
        console.log(e.message)
        console.log(e)
      }
    }
  })
}
